import React, { useState, useEffect } from "react";
import { setDataInStorageHelper } from "../helper/helper";
import { useFocusable, FocusContext } from "@noriginmedia/norigin-spatial-navigation";

const MassiveDialog = ({ onConsent }) => {
    const { ref, focusKey, setFocus } = useFocusable({
        isFocusBoundary: true,
    });

    const { ref: acceptBtnRef, focused: acceptBtnFocused } = useFocusable({
        focusKey: 'ACCEPT_BTN',
        onEnterPress: () => handleConsent(true),
    });

    const { ref: declineBtnRef, focused: declineBtnFocused } = useFocusable({
        focusKey: 'DECLINE_BTN',
        onEnterPress: () => handleConsent(false),
    });

    useEffect(() => {
        setFocus('ACCEPT_BTN');
    }, [setFocus]);

    const handleConsent = (isAccepted) => {
        // Save to local storage
        setDataInStorageHelper("massive_consent", isAccepted);

        if (onConsent) {
            onConsent(isAccepted);
        }
    };

    const styles = {
        overlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(27, 10, 55, 0.95)', // $theme-bgColor-primary with opacity
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            color: '#ffffff', // $heading-color-primary
            flexDirection: 'column'
        },
        card: {
            maxWidth: '90%',
            width: '500px',
            backgroundColor: 'rgba(255, 255, 255, 0.05)', // Light opacity card background
            padding: '40px',
            borderRadius: '20px',
            textAlign: 'center',
            backdropFilter: 'blur(10px)', // Glassmorphism effect
            border: '1px solid rgba(255, 255, 255, 0.1)',
            boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)'
        },
        button: {
            padding: '12px 30px',
            margin: '15px',
            border: 'none',
            borderRadius: '25px', // Rounded buttons
            cursor: 'pointer',
            fontSize: '18px',
            fontWeight: '600',
            backgroundColor: 'rgba(255,255,255,0.1)', // Glassy button
            color: '#ffffff',
            transition: 'all 0.2s ease',
            minWidth: '150px'
        },
        focused: {
            backgroundColor: '#db4827', // $theme-bgColor-secondary
            transform: 'scale(1.1)',
            boxShadow: '0 0 15px rgba(219, 72, 39, 0.6)'
        },
        text: {
            fontSize: '20px',
            marginBottom: '30px',
            color: '#d4d2d6', // $heading-color-secondary
            lineHeight: '1.6'
        }
    };

    return (
        <FocusContext.Provider value={focusKey}>
            <div style={styles.overlay} ref={ref}>
                <div style={styles.card} className="massive-dialog-card">
                    <h4>Purple Massive Consent</h4>
                    <p style={styles.text}>
                        To remove ads and get free content, please allow Massive to use
                        a small amount of device resources and IP address.
                    </p>

                    <div className="button-group">
                        <button
                            ref={acceptBtnRef}
                            style={{
                                ...styles.button,
                                ...(acceptBtnFocused ? styles.focused : {}),
                            }}
                            onClick={() => handleConsent(true)}
                        >
                            Accept
                        </button>

                        <button
                            ref={declineBtnRef}
                            style={{
                                ...styles.button,
                                ...(declineBtnFocused ? styles.focused : {}),
                            }}
                            onClick={() => handleConsent(false)}
                        >
                            Decline
                        </button>
                    </div>
                </div>
            </div>
        </FocusContext.Provider>
    );
};

export default MassiveDialog;
